/**
 * Constants related to the supported deep link actions.
 */

/**
 * Open the payment dialog once the sale has been loaded.
 */
export const PAY = 'pay'

/**
 * Navigate directly to the payment screen to pay a customer's account balance.
 * Used when monocle navigates to /webregister/pay-account-balance?customerId=...
 */
export const PAY_ACCOUNT_BALANCE = 'pay_account_balance'

/**
 * Close the webRegister tab once the sale has been completed
 */
export const VEND_API_LOAD_SALE_CLOSE_AFTER_COMPLETE =
  'VEND_API_LOAD_SALE_CLOSE_AFTER_COMPLETE'
